export const PRAYERS_BAUTISMO = [
  'Jesús, quédate conmigo \npara siempre.',
  'Jesús, llena mi corazón de amor. \nAyúdame a seguirte con alegría.',
  'Jesús, sé mi guía. \nAcompáñame hoy y siempre.',
  'Jesús, en Ti confío.',
  'Jesús, recibe mi corazón. \nHaz que viva siempre cerca de Ti.',
  'Señor, haz de mí\nun instrumento de Tu paz.',
  'Dios, cuida de mí con ternura. \nHaz que nunca me aparte de Ti.',
  'Espíritu Santo, ilumina mi camino. \nQue siempre siga la voluntad de Dios.',
  'Espíritu Santo, habita siempre en mi corazón. \nGuía mis pasos hacia Jesús.',
  'Que la ternura \nsea siempre mi camino.',
];

export const PRAYERS_COMUNION = [
  'Jesús, quédate conmigo \npara siempre.',
  'Jesús, en Ti confío.',
  'Jesús, sé mi guía. \nAcompáñame hoy y siempre.',
  'Jesús, Pan de Vida.\nAliméntame siempre con Tu amor.',
  'Gracias, Señor, por el regalo de la Eucaristía. \nHazme crecer en tu amor cada día.',
  'Señor, aumenta mi fe. \nHazme vivir siempre en Tu gracia.',
  'Señor, que nunca me aparte de Ti.',
  'Que cada Comunión me acerque más a Ti.',
  'Haz de mi corazón tu hogar.',
  'María, llévame siempre hacia Jesús.',
  'María, acompáñame siempre.',
];
